<nav class="navbar navbar-expand-lg fixed-top navbar-default">
  <!-- navbar-expand-lg steuert, wann der Toggler erscheint -->
  <button class="navbar-toggler" type="button" (click)="isOpen()">
    <i class="fa-light fa-bars"></i>
  </button>
  <a
    class="navbar-brand"
    href="javascript:void(0)"
    (click)="onDashboardClickImage()"
  >
    <picture>
      <source
        srcset="assets/img/icons/web-app-logo/logo-dark.svg"
        media="(prefers-color-scheme: dark)"
      />
      <img
        src="assets/img/icons/web-app-logo/logo-light.svg"
        alt="FixPlaner"
        width="40"
        height="40"
      />
    </picture>
    <img
      src="../../../../../assets/img/logo-text.svg"
      alt="FixPlaner"
      class="d-none d-sm-inline-block logo-text"
    />
    <!-- Text-Logo auf sehr kleinen Screens ausblenden -->
  </a>

  <div
    [class.show]="!isMenuCollapsed"
    class="collapse navbar-collapse"
    id="navbarSupportedContent"
  >
    <ul
      *ngIf="!isRegisteredStepper"
      class="navbar-nav me-auto my-2 my-lg-0 navbar-nav-scroll"
    >
      <!-- Beispiel für einen Nav-Link, der im HTML gleich bleibt -->
      <li
        *ngIf="authService.isManegeOrTeamLeader"
        class="nav-item"
        [ngClass]="{ active: router.url === '/dashboard' }"
      >
        <a
          class="nav-link"
          (click)="onDashboardClick()"
          href="javascript:void(0)"
          [xdsTooltip]="'DASHBOARD.TITLE' | translate"
          xdsTooltipPosition="bottom"
        >
          <i class="fas fa-desktop"></i
          ><span class="nav-link-text">{{ "DASHBOARD.TITLE" | translate }}</span
          ><span class="sr-only">{{ "COMMON.CURRENT_PAGE" | translate }}</span>
        </a>
      </li>
      <!-- ... andere Navigationspunkte folgen dem gleichen Muster ... -->
      <!-- WICHTIG: Füge die Klasse nav-link-text zu den <span> Elementen hinzu, die den Text enthalten -->
      <li
        *ngIf="!authService.isManegeOrTeamLeader"
        class="nav-item"
        [ngClass]="{ active: router.url === '/employeedashboard' }"
      >
        <a
          class="nav-link"
          (click)="onEmployeeDashboardClick()"
          href="javascript:void(0)"
          [xdsTooltip]="'DASHBOARD.TITLE' | translate"
          xdsTooltipPosition="bottom"
        >
          <i class="fas fa-desktop"></i
          ><span class="nav-link-text">{{ "DASHBOARD.TITLE" | translate }}</span
          ><span class="sr-only">{{ "COMMON.CURRENT_PAGE" | translate }}</span>
        </a>
      </li>
      <li
        *ngIf="
          authService.isManegeOrTeamLeader &&
          companySettingsService.CompanySettings?.ShiftSettings?.ShiftPlanerActive
        "
        class="nav-item"
        [ngClass]="{ active: router.url === '/planner' }"
      >
        <a
          class="nav-link"
          (click)="onPlannerClick()"
          href="javascript:void(0)"
          [xdsTooltip]="'Planner' | translate"
          xdsTooltipPosition="bottom"
        >
          <!-- Muss mit der Sidebar uebereinstimmen (admin-sidebar.component.html:119): dieselbe
               Funktion darf nicht in zwei Navigationen zwei Zeichen tragen. Vorher `fa-tasks`,
               der Altname von fa-list-check und damit das Aufgaben-Zeichen. `fa-solid` auch hier,
               weil die Zeiterfassung zwei Eintraege weiter ein leichtes fa-calendar-clock fuehrt. -->
          <i class="fa-solid fa-calendar-days"></i
          ><span class="nav-link-text">{{ "Planner" | translate }}</span>
        </a>
      </li>
      <!-- ... und so weiter für alle Hauptnavigationspunkte ... -->
      <li
        *ngIf="
          authService.isManegeOrTeamLeader &&
          subscriptionService.hasFeature(3) &&
          companySettingsService.CompanySettings.ShiftSettings.ShiftPlanerActive
        "
        class="nav-item"
        [ngClass]="{ active: router.url === '/availability' }"
      >
        <a
          class="nav-link"
          (click)="onAvailabilityClick()"
          href="javascript:void(0)"
          [xdsTooltip]="'AVAILABILITY' | translate"
          xdsTooltipPosition="bottom"
        >
          <i class="fa-light fa-user-check"></i
          ><span class="nav-link-text">{{ "AVAILABILITY" | translate }}</span>
        </a>
      </li>
      <li
        *ngIf="authService.isManegeOrTeamLeader"
        class="nav-item"
        [ngClass]="{ active: router.url === '/employee' }"
      >
        <a
          class="nav-link"
          (click)="onEmployeeClick()"
          href="javascript:void(0)"
          [xdsTooltip]="'Employee' | translate"
          xdsTooltipPosition="bottom"
        >
          <i class="fa-solid fa-users-gear"></i
          ><span class="nav-link-text">{{ "Employee" | translate }}</span>
        </a>
      </li>
      <li
        *ngIf="
          authService.isManegeOrTeamLeader &&
          subscriptionService.hasFeature(9) &&
          companySettingsService.CompanySettings.TimeTrackingSettings
            .TimeTrackingActive
        "
        class="nav-item"
        [ngClass]="{ active: router.url === '/time-recording' }"
      >
        <a
          class="nav-link"
          (click)="onTimeRecordingClick()"
          href="javascript:void(0)"
          [xdsTooltip]="'TIME TRACKING' | translate"
          xdsTooltipPosition="bottom"
        >
          <i class="fa-light fa-calendar-clock"></i
          ><span class="nav-link-text">{{ "TIME TRACKING" | translate }}</span>
        </a>
      </li>
      <li
        *ngIf="authService.isManegeOrTeamLeader"
        class="nav-item"
        [ngClass]="{ active: router.url === '/absence' }"
      >
        <a
          class="nav-link"
          (click)="onAbsenceClick()"
          href="javascript:void(0)"
          [xdsTooltip]="'Absence' | translate"
          xdsTooltipPosition="bottom"
        >
          <i class="fa-light fa-house-person-leave"></i
          ><span class="nav-link-text">{{ "Absence" | translate }}</span>
        </a>
      </li>
      <!-- E1 (Planning-Redesign, 2026-06-10): Menüpunkt „Personalbedarf"
           entfernt — aufgegangen im ▦-Muster-Modus der Planung
           (/planner?view=muster); alte Route leitet um. -->
      <li
        *ngIf="authService.isManegeOrTeamLeader"
        class="nav-item"
        [ngClass]="{ active: router.url === '/settings' }"
      >
        <a
          class="nav-link"
          (click)="onSettingsClick()"
          href="javascript:void(0)"
          [xdsTooltip]="'SETTINGS' | translate"
          xdsTooltipPosition="bottom"
        >
          <i class="fa-light fa-gears"></i
          ><span class="nav-link-text">{{ "SETTINGS.TITLE" | translate }}</span>
        </a>
      </li>
    </ul>

    <ul class="navbar-nav ms-auto">
      <li class="nav-item top-actions-slot">
        <app-top-actions-bar></app-top-actions-bar>
      </li>
    </ul>
  </div>

  <div *ngIf="loading" class="progress-container">
    <xds-progress [indeterminate]="true"></xds-progress>
  </div>
</nav>
